import { NgModule, LOCALE_ID, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { registerLocaleData, LocationStrategy, HashLocationStrategy } from '@angular/common';
import localePt from '@angular/common/locales/pt';
registerLocaleData(localePt);

import { AppRouting } from './app.routing';

import { DialogModule } from 'primeng/dialog';
import { MessageService } from 'primeng/components/common/messageservice';

import { GestaoSsService } from './components/shared/services/gestao-ss.service';
import { AuthService } from './components/admin/auth.service';
import { SispacErrorHandler } from './components/shared/errors/sispac-error-handler';

import { SispacSharedModule } from './components/shared/sispac-shared.module';
import { AdminModule } from './components/admin/admin.module';
import { FaseModule } from './components/fase/fase.module';
import { CandidatoModule } from './components/candidato/candidato.module';
import { ConsultaCnpjModule } from './components/consultaCnpj/consulta-cnpj.module';
import { EditalCredenciamentoModule } from './components/editalCredenciamento/edital-credenciamento.module';
import { CfcModule } from './components/cfc/cfc.module';
import { ClinicaModule } from './components/clinica/clinica.module';
import { LaboratorioModule } from './components/laboratorio/laboratorio.module';
import { EtapaModule } from './components/etapa/etapa.module';
import { ExameToxicologicoModule } from './components/exameToxicologico/exame-toxicologico.module';
import { ExameMedicoPsicologicoModule } from './components/exameMedicoPsicologico/exame-medico-psicologico.module';
import { CursoPraticoModule } from './components/cursoPratico/curso-pratico.module';
import { ProvaPraticaModule } from './components/provaPratica/prova-pratica.module';
import { FaseUnidadeModule } from './components/faseUnidade/faseUnidade.module';

import { NotFoundComponent } from './components/home/not-found/not-found.component';
import { HomeComponent } from './components/_admin-layout/home/home.component';

import { InscricaoService } from './services/inscricao.service';
import { SigopServiceService } from './services/sigop-service.service';
import { CandidatoCursoEspecializadoService } from './services/candidato-curso-especializado.service';
import { UnidadeModule } from './components/unidade/unidade.module';
import { FinanceiroModule } from './components/financeiro/financeiro.module';
import { ExcelService } from './services/excel.service';

import { VersionCheckService } from './services/version-check-service.service';

import {MultiSelectModule} from 'primeng/multiselect';
import { PublicModule } from './components/_public-layout/public-layout.module';
import { PublicRouting } from './components/_public-layout/public-layout.routing';
import { AppComponent } from './app.component';
import { PublicLayoutComponent } from './components/_public-layout/public-layout.component';
import { AdminLayoutComponent } from './components/_admin-layout/admin-layout.component';
import { AdminRouting } from './components/admin/admin.routing';
import { SispacLayoutComponent } from './components/_admin-layout/sispac-layout/sispac-layout.component';
import { HeadBarComponent } from './components/_admin-layout/head-bar/head-bar.component';
import { GrowlModule } from 'primeng/primeng';
import { EmpresaService } from './services/empresa.service';
import { VagaModule } from './components/vaga/vaga.module';
import { TableModule } from 'primeng/table';
import { PropostaModule } from './components/proposta/proposta.module';

@NgModule({
  imports: [
    BrowserModule, NoopAnimationsModule, HttpClientModule,
        
    DialogModule,
    AppRouting,
    AdminRouting,
    GrowlModule,
    SispacSharedModule, AdminModule,
    FaseModule, CandidatoModule, ConsultaCnpjModule,
    EditalCredenciamentoModule, CfcModule, ClinicaModule, LaboratorioModule,
    EtapaModule, ExameToxicologicoModule, ExameMedicoPsicologicoModule, CursoPraticoModule, ProvaPraticaModule, FaseUnidadeModule,
    UnidadeModule, FinanceiroModule,
    PropostaModule,
    MultiSelectModule,
    AdminModule,
    PublicModule,
    PublicRouting,
    VagaModule,
    TableModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt'},
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: ErrorHandler, useClass: SispacErrorHandler },

    MessageService,
    InscricaoService,
    SigopServiceService,
    GestaoSsService,
    VersionCheckService,
    CandidatoCursoEspecializadoService,
    AuthService,
    ExcelService,
    EmpresaService,
  ],
  declarations: [
    HomeComponent,
    NotFoundComponent,
    AppComponent,
    AdminLayoutComponent,
    PublicLayoutComponent,
    SispacLayoutComponent,
    HeadBarComponent,
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule {


}



// WEBPACK FOOTER //
// ./src/app/app.module.ts